import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Wrapper = styled(Link)`
    text-decoration-thickness: 0.05em;
    &:link {
        color: ${({ theme }) => theme.link};
    }
    &:visited {
        color: ${({ theme }) => theme.link};
    }
    &:hover {
        color: ${({ theme }) => theme.highlight}
    }
    &:active {
        color: ${({ theme }) => theme.active}
    }
`

const HSLink = ({ ...props }) => {
    return (
        <Wrapper {...props}>
            {props.children}
        </Wrapper >
    )
};

export default HSLink;
